import { useState } from "react";
import {
  ResponseGetRemarksTemplateResponse,
  RemarksTemplateApi,
  RequestUpdateRemarksTemplateRequest,
  RemarksTemplateUpdateRemarksTemplatePostRequest,
} from "../../services/OpenAPI";
import { createConfiguration } from "./common";

export const useApiUpdateRemarksTemplate = () => {
  const [remarksTemplateList, setRemarksTemplateList] = useState<
    ResponseGetRemarksTemplateResponse[] | null
  >([]);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const updateRemarksTemplate = async (
    req: RequestUpdateRemarksTemplateRequest,
  ) => {
    setIsLoading(true);
    setError(null);

    try {
      setIsLoading(true);
      const config = createConfiguration();
      const request: RemarksTemplateUpdateRemarksTemplatePostRequest = {
        req,
      };

      const api = new RemarksTemplateApi(config);
      const response =
        await api.remarksTemplateUpdateRemarksTemplatePost(request);
      setRemarksTemplateList(response);
      return response;
    } catch (err: any) {
      setError("備考の更新に失敗しました");
      console.error(err);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return { updateRemarksTemplate, remarksTemplateList, error, isLoading };
};
